import { Controller } from '@hotwired/stimulus'

// Shows clothing listing-mode choices only when the shelf kind is Fashion / clothing.
export default class extends Controller {
  static targets = ['kind', 'listingMode']
  static values = {
    clothingKind: { type: String, default: 'clothing-fashion' }
  }

  connect () {
    this.refresh()
  }

  refresh () {
    if (!this.hasListingModeTarget) return

    const isClothing = this.hasKindTarget && this.kindTarget.value === this.clothingKindValue
    this.listingModeTarget.classList.toggle('hidden', !isClothing)
    this.listingModeTarget.querySelectorAll('input[type="radio"]').forEach((input) => {
      input.disabled = !isClothing
    })
  }
}
